export default __webpack_public_path__ + "static/media/Merchant.c60bb336.png";